// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.manage-notification {
  margin: 0 16.66%;
}

.pageHeadingedit {
  font-size: 32px;
  color: #000000;
  font: normal normal normal 24px/21px ATT Aleck Sans;
}

.edit-text {
  font-size: 16px;
  color: #000000;
}

label {
  font-size: 16px !important;
  font-weight: normal !important;
  font: 14px "Omnes-ATT-W02", "Arial";
}

.form-group {
  margin-left: 0px !important;
}

#email {
  width: 20px;
  height: 16px;
}

input[type=checkbox] {
  border: 1px solid #1483D9 !important;
}

.check-data {
  margin-bottom: 15px;
}

.buttons-section {
  border-top: 1px solid #d2d2d2;
  margin-top: 10px;
  padding: 30px 0 60px;
}
@media (max-width: 1024px) {
  .buttons-section {
    padding: 60px 0 60px;
  }
}
.buttons-section .btnCancel {
  font: 1.8rem;
}
.buttons-section .btn-cancel {
  margin-right: 10px;
}

@media (max-width: 1024px) {
  .manage-notification {
    margin: 0 16.66%;
    margin-top: 50px;
  }
}
.tooltip-input {
  width: 30px;
  left: 150px;
  top: -30px;
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -190px;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 980px) and (min-width: 400px) {
  .tooltip-input {
    right: -190px;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .tooltip-input {
    right: -170px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .tooltip-input {
    right: -190px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -200px;
    bottom: -5px;
    width: 20px;
  }
}

i.tooltip-icon.tooltipActive:after {
  top: 22px;
}

@media (max-width: 1024px) {
  .faq-tooltip-icon {
    margin-right: 5px;
  }
}
.tooltipActive + .helper-text {
  display: block;
  text-align: center !important;
  width: 950%;
  margin-bottom: 0px !important;
  bottom: 100%;
  margin-left: -130px;
  z-index: 1;
  height: 70px;
  top: 37px;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 120px !important;
    margin-left: -64px;
    height: 68px;
  }
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    width: 1265% !important;
    margin-left: -125px;
    border-radius: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-inventory/managenotifications/managenotifications.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,gBAAA;AAmJJ;;AAjJA;EACI,eAAA;EACA,cAAA;EACA,mDAAA;AAoJJ;;AAlJA;EACI,eAAA;EACA,cAAA;AAqJJ;;AAnJA;EACI,0BAAA;EACA,8BAAA;EACA,mCAAA;AAsJJ;;AApJA;EACI,2BAAA;AAuJJ;;AArJA;EACI,WAAA;EACA,YAAA;AAwJJ;;AApJA;EACG,oCAAA;AAuJH;;AApJA;EACI,mBAAA;AAuJJ;;AApJA;EACI,6BAAA;EACA,gBAAA;EACA,oBAAA;AAuJJ;AFtKI;EEYJ;IAMQ,oBAAA;EAwJN;AACF;AAtJI;EACE,YAAA;AAwJN;AAtJI;EACE,kBAAA;AAwJN;;AFjLI;EE8BA;IACI,gBAAA;IACA,gBAAA;EAuJN;AACF;AAlJA;EAGI,WAAA;EACA,WAAA;EACA,UAAA;AAkJJ;AF7LI;EEsCJ;IAQQ,aAAA;IACA,YAAA;IACA,WAAA;EAmJN;AACF;AAlJI;EAZJ;IAaQ,aAAA;IACA,YAAA;IACA,WAAA;EAqJN;AACF;AApJI;EAjBJ;IAkBQ,wBAAA;IACA,YAAA;IACA,WAAA;EAuJN;AACF;AAtJM;EAtBN;IAuBQ,wBAAA;IACA,YAAA;IACA,WAAA;EAyJN;AACF;AAxJM;EA3BN;IA4BQ,aAAA;IACA,YAAA;IACA,WAAA;EA2JN;AACF;;AAvJA;EACI,SAAA;AA0JJ;;AAvJA;EACI;IACI,iBAAA;EA0JN;AACF;AAvJI;EACI,cAAA;EACA,6BAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;AAyJR;AFrPI;EEmFA;IAWQ,uBAAA;IACA,kBAAA;IACA,YAAA;EA2JV;AACF;AAzJQ;EAhBJ;IAiBQ,uBAAA;IACA,mBAAA;IACA,kBAAA;EA4JV;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.manage-notification{\n    margin: 0 16.66%;\n}\n.pageHeadingedit{\n    font-size:32px;\n    color: #000000;\n    font: normal normal normal 24px/21px ATT Aleck Sans;\n}\n.edit-text{\n    font-size:16px;\n    color:#000000;\n}\nlabel{\n    font-size:16px!important;\n    font-weight:normal!important;\n    font: 14px 'Omnes-ATT-W02', 'Arial';\n}\n.form-group{\n    margin-left:0px!important;\n}\n#email{\n    width: 20px;\n    height: 16px;\n  \n}\n\ninput[type=checkbox]  {\n   border: 1px solid #1483D9!important;\n}\n\n.check-data{\n    margin-bottom:15px;\n}\n\n.buttons-section {\n    border-top: 1px solid color(default, dark);\n    margin-top: 10px;\n    padding: 30px 0 60px;\n\n    @include respond-to(small) {\n        padding: 60px 0 60px;\n    }\n\n    .btnCancel {\n      font: 1.8rem;\n    }\n    .btn-cancel {\n      margin-right: 10px;\n    }\n  }\n\n@include respond-to(small) {\n    .manage-notification{\n        margin: 0 16.66%;\n        margin-top: 50px;\n    }\n}\n\n\n\n.tooltip-input {\n    // right: -685px;\n    // bottom: -5px;\n    width: 30px;\n    left: 150px;\n    top: -30px;\n\n    @include respond-to('small') {\n        right: -190px;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media(max-width: 980px) and (min-width:400px) {\n        right: -190px ;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n        right: -170px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        right: -190px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media(max-width: 1024px) {\n        right: -200px ;\n        bottom: -5px;\n        width: 20px;\n      }\n     \n} \n\ni.tooltip-icon.tooltipActive:after {\n    top: 22px;\n}\n\n@media(max-width: 1024px) {\n    .faq-tooltip-icon {\n        margin-right: 5px;\n    }\n    }\n\n    .tooltipActive + .helper-text {\n        display: block;\n        text-align: center !important;\n        width: 950%;\n        margin-bottom: 0px !important;\n        bottom: 100%;\n        margin-left: -130px;\n        z-index:1;\n        height: 70px;\n        top: 37px;\n        @include respond-to('small') {\n            width: 120px !important;\n            margin-left: -64px;\n            height: 68px;\n        }\n    \n        @media(max-width: 1024px) {\n            width: 1265% !important;\n            margin-left: -125px;\n            border-radius: 8px;\n        }\n    }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
